<template>
  <component
    :is="tag"
    :href="tag !== 'button' ? url : null"
    :to="tag === 'nuxt-link' ? url : null"
    :target="target"
    :theme="theme"
    :class="[classes, `button--${theme}`]"
    @click="onClick"
  >
    <span class="button__text">
      <slot />
    </span>
  </component>
</template>

<script>
  export default {
    name: 'BaseButton',

    props: {
      url: {
        type: String,
        default: ''
      },
      target: {
        type: String
      },
      theme: {
        type: String,
        default: 'main',
        validator: (v) => ['main', 'white'].includes(v)
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      classes () {
        return [
          'button',
          { button_disabled: this.disabled }
        ]
      },
      tag () {
        if (!this.url) {
          return 'button'
        } else if (/(http|https)|(tel:)|(mailto:)/.test(this.url) || this.target === '_blank') {
          return 'a'
        } else {
          return 'nuxt-link'
        }
      }
    },

    methods: {
      onClick (event) {
        if (this.tag === 'nuxt-link') {
          event.preventDefault()
        }

        if (this.disabled) return

        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss">
  .button {
    position: relative;
    display: inline-flex;
    align-items: center;
    border-radius: 50px;
    justify-content: center;
    min-width: 180px;
    padding: 19px 58px;
    text-decoration: none;
    cursor: pointer;
    background-color: $c-red;
    border: none;
    outline: none;
    transition: 0.5s;

    @include mobile {
      min-width: 100%;
      font-size: 12px;
      line-height: 16;
      padding: 15px 20px;
    }

    &_disabled {
      pointer-events: none;
      background-color: #D0D3D4;
    }

    &__text {
      color: $c-white;
      font-family: 'FuturaPT';
      font-size: 18px;
      font-weight: 500;
      line-height: 1;
      text-transform: uppercase;

      @include mobile {
        font-size: 12px;
        line-height: 16px;
      }
    }

    @include hover {
      background-color: $c-dark-red;
    }

    &--white {
      min-width: 128px;
      font-size: 14px;
      line-height: 16px;
      padding: 13px 20px;
      background-color: transparent;
      border: 2px solid $c-yellow;
      transition: 0.5s;

      @include mobile {
        font-size: 12px;
        line-height: 16px;
      }

      .button__text {
        color: $c-yellow;
      }

      @include hover {
        border-color: $c-orange;
        background-color: transparent;

        .button__text {
          color: $c-orange;
        }
      }

      &.button_disabled {
        border-color: #D0D3D4;

        .button__text {
          color: $c-light-black;
        }
      }
    }
  }
</style>
